import ErrorComponent from "@/components/atoms/ErrorComponent";
import InstructorHeader from "@/components/molecules/card-headers/instructors/InstructorHeader";
import InstructorEditCard from "@/components/molecules/cards/instructors/InstructorEditCard";
import { UUID_REGEX } from "@/constants/regexs";
import { FC } from "react";
import { useParams } from "react-router-dom";

const InstructorEditView: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page formalys-edit-page">
      <InstructorHeader id={id} isEdit />
      <InstructorEditCard id={id} />
    </div>
  );
};

export default InstructorEditView;
